import cn from 'classnames';
import { forwardRef } from 'react';

import { SimpleTooltip, simpleTTOuterClass } from '@webapp/common/components/simple-tooltip';

import css from './actions-bar.css';

export interface ActionBarItem {
    icon?: ReactNode;
    title?: string;
    visible?: (item: any) => boolean;
    onClick?: (item: any) => void;
    disabled?: boolean;
    content?: ReactNode;
}

export type ActionBarItems = Array<ActionBarItem>;

export const ActionsBar = forwardRef<
    HTMLDivElement,
    {
        actions: Array<ActionBarItem>;
        item?: any;
        style?: CSSProperties;
        className?: string;
        children?: any;
        ellipse?: boolean;
        disabled?: boolean;
        borderRadiusPosition?: 'left' | 'right';
    }
>(({ actions, children, className, disabled, ellipse, item, borderRadiusPosition = 'left', ...rest }, ref) => (
    <div
        className={cn(
            css.actions,
            css[`actions_border-radius-${borderRadiusPosition}`],
            ellipse && css.ellipse,
            disabled && css.disabled,
            className,
        )}
        ref={ref}
        {...rest}
    >
        {actions.map(({ icon, onClick, title, disabled }, idx) => (
            <div
                className={cn(css.action, simpleTTOuterClass, { [css.action_disabled]: disabled })}
                key={idx}
                onClick={
                    disabled
                        ? undefined
                        : (e) => {
                              e.stopPropagation();
                              onClick?.(item);
                          }
                }
            >
                {title && <SimpleTooltip title={title} />}
                {icon}
            </div>
        ))}
        {children}
    </div>
));
ActionsBar.displayName = 'ActionsBar';
